export default __webpack_public_path__ + "static/char-s-15-jp-8b229915521ffa518d77f5ba304fdf64.png";